module.exports = __webpack_public_path__ + "img/0Q3B7497_WoodMatted_MockedUp.ab05200e.jpg";